import { api } from '@/f1/service';
import * as forge from 'node-forge'
import * as _ from 'lodash'
import reg from '@/f1/reg'

import Language from './language';
import '../login.css';

//i18n_data
import i18n_toastr from './i18n_data'
import i18n_data from '@/component/i18n_data';

export default {
  components: { Language },
  data: function () {
    return {
      // i18n_msg,
      checked: false,
      error: '',
      model: { username: '', password: '' },
      password_meter : { is_spacial : false, is_alphabat_upper : false, is_alphabat_lower : false, is_number : false, check_length : false, min_length : 10  },
      group_password_policy : {},
      lock: false,
      lock_btn : false,
      reset : false
    }
  },
  computed: {
    // i18n_data() { return _i18n_data; }
    // ts() { return this.$ts(wordset, this.$store.getters.lang) }
  },
  methods: {
    password_policy(type = '')
    {
      switch (type) {
        case 'number':
          this.password_meter.is_number = this.model.password_new && reg.reg_number.test(this.model.password_new) ? true : false;
          return this.password_meter.is_number;
        case 'uppercase':
          this.password_meter.is_alphabat_upper = this.model.password_new && reg.reg_alphabat_upper.test(this.model.password_new) ? true : false;
          return this.password_meter.is_alphabat_upper;
        case 'lowercase':
          this.password_meter.is_alphabat_lower = this.model.password_new && reg.reg_alphabat_lower.test(this.model.password_new) ? true : false;
          return this.password_meter.is_alphabat_lower;
        case 'spacial':
          this.password_meter.is_spacial = this.model.password_new && reg.reg_spacial.test(this.model.password_new) ? true : false;
          return this.password_meter.is_spacial;
        case 'length':
          this.password_meter.check_length = (this.model.password_new && this.model.password_new.length >= this.password_meter.min_length) ? true : false
          return this.password_meter.check_length;
        // eslint-disable-next-line no-case-declarations
        case 'all':
          let keys = Object.keys(this.password_meter);
          for (let i = 0; i < keys.length; i++) {
            // if has can't pass
            if(!this.password_meter[keys[i]]) { return { is_error : true, key : keys[i] }; }
          }
          // all pass
          return { is_error : false };
        default:
          return false;
      }
    },
    otpToken: function () {
      this.error = '';
      if(_.isEmpty(this.model.username)) { return this.$toastr.e(`${i18n_data._i18n_warning.otpToken[this.LangStatus]}` || 'Plz, Typing email'); }
      if(!reg.email.test(this.model.username)) { return this.$toastr.w(`${i18n_data._i18n_warning.otpToken_2[this.LangStatus]}` || 'typing was not email format');}

      this.model.url = location.hostname == 'localhost' ? `${location.protocol}//${location.host}/#/reset` : `${location.protocol}//${location.hostname}:${location.port}/#/reset`
      this.lock = true;
      this.lock_btn = true;
      // api.auth.tokenReset(this.model).then((rs) => {
      api.auth.ResetPassword(this.model).then((rs) => {
        if(rs.error) { return this.$toastr.e(`${i18n_toastr._i18n_error.otpToken[this.LangStatus]}` || "reset failed") }
        setTimeout(() => {
          this.lock_btn = false;
        }, 3 * 60 * 1000);
        this.$toastr.i(`${i18n_toastr._i18n_info.token_expire[this.LangStatus]}` || 'Auth token expire later 3 min');
        window.localStorage.setItem('username', this.model.username)

      }).catch(e => { console.log(e); this.lock_btn = false; this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)});
    },
    otpVerify: async function (token = this.$route.query.token, username = this.$route.query.username) {
      // console.log("token11", token)
      if(!token) { return; }
      await api.auth.tokenVerify({ token : token }).then((rs) => {
        if(!rs) {
          this.$toastr.e(`${i18n_toastr._i18n_warning.otpVerify[this.LangStatus]}` || "expired, not allowed, try request auth email again")
        } else {
          if(rs && rs.password_min_len > 0) {
            this.group_password_policy = rs;
            this.password_meter.min_length = this.group_password_policy.password_min_len < this.password_meter.min_length ? this.password_meter.min_length : this.group_password_policy.password_min_len
          }
          if(username) { this.model.username = username.replace(/ /g, '+') } // bug?
          this.reset = true; return this.$toastr.i(`${i18n_toastr._i18n_info.authorize_sucess[this.LangStatus]}` || 'Authorize successfully', 'done');
        }
      }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText))
    },
    newPassword () {
      if(_.isEmpty(this.model.password_new)) { return this.$toastr.e(`${i18n_toastr._i18n_warning.newPassword[this.LangStatus]}` || 'Typing new password'); }
      if(_.isEmpty(this.model.password_new_repeat)) { return this.$toastr.e(`${i18n_toastr._i18n_warning.newPassword_2[this.LangStatus]}` || 'Typing new password repeat'); }
      if(this.model.password_new_repeat != this.model.password_new) { return this.$toastr.e(`${i18n_toastr._i18n_warning.newPassword_3[this.LangStatus]}` || 'not same password and password repeat'); }

      let policy_count = -3
      if(this.group_password_policy.password_use_alphabet) { policy_count+=1 }
      if(this.group_password_policy.password_use_spacial) { policy_count+=1 }
      if(this.group_password_policy.password_use_number) { policy_count+=1 }

      // 그룹 정책에서 최소한의 정책이 없을 경우, 시스템 정책을 따른다
      if(policy_count < 0) {
        var rs = this.password_policy('all')
        if(rs.is_error) {
          var msg = rs.key.indexOf('is') > -1 ? rs.key.substring(3) : rs.key;
          return this.$toastr.e(`${i18n_data._i18n_warning.newPassword[this.LangStatus]}` || `Please check password policy [${msg}]`);
        }
      } else {
        if(this.group_password_policy) {
          if(this.group_password_policy.password_use_alphabet && (!this.password_policy('uppercase') && !this.password_policy('lowercase'))) { return this.$toastr.e(`${i18n_data._i18n_warning.newPassword_2[this.LangStatus]}` || "check password typing alphabet") }
          if(this.group_password_policy.password_use_spacial && !this.password_policy('spacial')) { return this.$toastr.e(`${i18n_data._i18n_warning.newPassword_3[this.LangStatus]}` || "check password typing spacial") }
          if(this.group_password_policy.password_use_number && !this.password_policy('number')) { return this.$toastr.e(`${i18n_data._i18n_warning.newPassword_4[this.LangStatus]}` || "check password typing number") }
          if(this.group_password_policy.password_min_len > 0 && !this.password_policy('length')) { return this.$toastr.e(`${i18n_data._i18n_warning.newPassword_6[this.LangStatus]}` || "password length more then " + this.password_meter.min_length) }
        } else { return this.$toastr.e(`${i18n_data._i18n_warning.newPassword_5[this.LangStatus]}` || "require group info") }
      }

      let user = {
        username : this.model.username,
        token : this.$route.query.token,
        new_password : forge.sha256.create().update(this.model.password_new).digest().toHex() // salt update
      }
      console.info(user)
      // api.auth.ResetPassword(user).then(() => {
      api.auth.tokenReset(user).then(() => {
        alert(i18n_toastr._i18n_info._i18n_alert[this.LangStatus] || "changed successfully");
        this.$router.push({ name: 'auth_login' });
      }).catch(e => {
        this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText);
        this.model.password_new_repeat = "";
        this.model.password_new = "";
        this.model.password = "";
        this.lock = false;
      })
    },
    format(val, event) {
      if(!event) { return val; }
      let rs = val.replace(/-/g, '')
      if(rs.length <= 3) { return `${rs.substring(0, 3)}` }
      else if(rs.length <= 5) { return `${rs.substring(0, 3)}-${rs.substring(3, 5)}` }
      else { return `${rs.substring(0, 3)}-${rs.substring(3, 5)}-${rs.substring(5, 10)}` }
    },
  },

  created: function() { console.log('login.vue', 'created'); },
  destroyed: function() { console.log('login.vue', 'destroyed'); },
  mounted: function() {
    console.log('login.vue mounted');
    this.otpVerify()
    if(window.localStorage.getItem('username')) { this.checked = true; this.model.username = window.localStorage.getItem('username'); }
  }
}
